/**
 * Component: Offcanvas navigation
 *
 */

var prongHorn = prongHorn || {};

prongHorn.offcanvas = prongHorn.offcanvas || function() {
    var self = this,
        $offcanvasWrap = $('#right-offcanvas');

    this.init = function() {

        self.showChildNavOnClick();
    }

    this.showChildNavOnClick = function() {
        var childTriggerClass = '.js-child-trigger';
        $offcanvasWrap.on('click', '.offcanvas-menu__list-item a', function(e) {
            console.log('a clicked', e)
        });
        console.log($('.offcanvas-menu__list-item a',$offcanvasWrap).length)
        console.log($(childTriggerClass,$offcanvasWrap).length)
        $offcanvasWrap.on('click', childTriggerClass, function(e) {
            console.log('BUTTON clicked', e)
            e.stopImmediatePropagation();
            e.stopPropagation();
            var $this = $(this),
            activeClass = 'offcanvas-menu--child__open',
            $thisSubnav = $this.parent().parent().children('.offcanvas-menu--child'),
            $subNavs = $('.offcanvas-menu--child');
            console.log($(this), e.target, '$thisSubnav',$thisSubnav)

            // Close all the open subnavs
            $subNavs.not($thisSubnav).removeClass(activeClass);
            $(childTriggerClass).not($this).removeClass('offcanvas-menu__child-trigger--rotate180');

            // Toggle the clicked submenu
            if(!$thisSubnav.hasClass(activeClass)) {
                $this.addClass('offcanvas-menu__child-trigger--rotate180');
                $thisSubnav.addClass(activeClass);
            } else {
                $this.removeClass('offcanvas-menu__child-trigger--rotate180');
                $thisSubnav.removeClass(activeClass);
            }
        });
    };

    // Public functions
    return {
        init: init
    };

}();